import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { IRecognitionGiver, IRecognitionGiverRecipient } from 'types/income';
import { exportXlsxConfig } from 'utils/general';
import { TableDataResponse } from 'types/general';
import {
  RecognitionGiverRecipientsFilters,
  RecognitionGiversFilters,
} from './recognition-givers.types';

const getFilters = (filters: Partial<RecognitionGiversFilters>) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  sort: filters.sort
    ? `${filters.sort.order === 'desc' ? '-' : ''}${filters.sort.columnKey}`
    : undefined,
  filter: {
    employeeName: filters.search || undefined,
    dateFrom: filters.date?.from,
    dateTo: filters.date?.to,
    achievementIds: filters.achievements,
  },
});

interface GetGivers {
  filters: Partial<RecognitionGiversFilters>;
}

interface GetGiverRecipients {
  employeeId: string;
  filters: Partial<RecognitionGiverRecipientsFilters>;
}

interface ExportXls {
  filters: Partial<RecognitionGiversFilters>;
}

export const loaders = {
  getGivers: ({ filters }: GetGivers) => {
    return api<{
      count: number;
      page: number;
      pageSize: number;
      employees: IRecognitionGiver[];
    }>({
      url: Endpoints.clientAdmin.recognitions.givers.root,
      params: {
        ...getFilters(filters),
      },
    });
  },
  getGiverRecipients: ({ employeeId, filters }: GetGiverRecipients) => {
    return api<TableDataResponse<IRecognitionGiverRecipient>>({
      url: Endpoints.clientAdmin.recognitions.givers.byId.replace(
        ':employeeId',
        employeeId,
      ),
      params: {
        filter: {
          dateFrom: filters.date?.from,
          dateTo: filters.date?.to,
          achievementIds: filters.achievements,
        },
      },
    });
  },
  exportXls: ({ filters }: ExportXls) => {
    const { page, pageSize, sort, ...restFilters } = getFilters(filters);
    return api({
      url: Endpoints.clientAdmin.recognitions.givers.export.xls,
      params: {
        ...restFilters,
      },
      ...exportXlsxConfig,
    });
  },
};
